"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
module.exports = /*#__PURE__*/function () {
  function PromiseManager() {
    (0, _classCallCheck2["default"])(this, PromiseManager);
  }
  return (0, _createClass2["default"])(PromiseManager, [{
    key: "timeout",
    get:
    // default timeout value
    function get() {
      return 30000;
    }
  }, {
    key: "setPromiseTimer",
    value: function setPromiseTimer(resolve, reject, option) {
      var _option$timeout = option.timeout,
        timeout = _option$timeout === void 0 ? this.timeout : _option$timeout,
        defaultValue = option.defaultValue;
      return setTimeout(function () {
        if (Entry.engine.state === 'run') {
          if (defaultValue !== undefined) {
            resolve(defaultValue);
          } else {
            reject('timeout');
          }
        }
      }, timeout);
    }

    /**
     * 입력한 time 만큼 일시정지한다.
     * pause 상태인 경우 로직을 수행하지 않고 멈춘다.
     * 시간은 그대로 흐르기 때문에 timeout 후 재시작하면 다음블록이 바로 실행된다.
     * 
     * @param time 일시정지할 ms
     */
  }, {
    key: "sleep",
    value: function sleep(time) {
      return new Promise(function (resolve) {
        setTimeout(/*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
          return _regenerator["default"].wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return waitWhilePause();
              case 1:
                resolve();
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        })), time);
      });
      function waitWhilePause() {
        return new Promise(function (resolve) {
          if (Entry.engine.state !== 'pause') {
            resolve();
          }
          var polling = setInterval(function () {
            if (Entry.engine.state !== 'pause') {
              window.clearInterval(polling);
              resolve();
            }
          }, 1000 / Entry.FPS);
        });
      }
    }

    /**
     * sample code
     * Entry.addEventListener('callApi', ({url}, resolve, reject) => {
     *     $.ajax(url).then((...args) => {
     *         console.log(args);
     *         resolve('asd');
     *     }).fail(() => {
     *         reject()
     *     });
     * });
     */
  }, {
    key: "EventPromise",
    value: (function () {
      var _EventPromise = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(key, data, option) {
        var _this = this;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.Promise(function (resolve, reject) {
                var defaultValue = option.defaultValue;
                var t = _this.setPromiseTimer(resolve, reject, option);
                Entry.dispatchEvent(key, data, function (value) {
                  clearTimeout(t);
                  resolve(value);
                }, function (value) {
                  clearTimeout(t);
                  if (defaultValue !== undefined) {
                    resolve(defaultValue);
                  } else {
                    reject(value);
                  }
                });
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function EventPromise(_x2, _x3, _x4) {
        return _EventPromise.apply(this, arguments);
      }
      return EventPromise;
    }())
  }, {
    key: "Promise",
    value: function (_Promise) {
      function Promise(_x) {
        return _Promise.apply(this, arguments);
      }
      Promise.toString = function () {
        return _Promise.toString();
      };
      return Promise;
    }(function (f) {
      return new Promise(function (resolve, reject) {
        var callback = function callback(data) {
          if (Entry.engine.state !== 'run') {
            reject(new Entry.Utils.AsyncError('Engine 정지'));
          } else {
            resolve(data);
          }
        };
        f(callback, reject);
      });
    })
  }]);
}();